import React from 'react';
import ReactDom from 'react-dom';
import Moment from 'moment';

import Const from 'fw_const';
import Utils from 'utils';
import DropDown from 'dropdown';

import CalenderCommon from '@common/calender/_calender';
import CastingList   from '@project/contents/calender/_post_list';

// =======================================================
// 1. リスト表示コンポーネント (ダミーデータ使用)
// =======================================================
class InfluencerList extends React.Component {
  render() {
    return (
      <CastingList data={this.props.data} />
    );
  }
}

// =======================================================
// 2. カレンダー表示コンポーネント (既存ロジック)
// =======================================================
class Calender extends React.Component {
  constructor(props) {
    super(props);
    this.init(props);
  }

  init(props) {
    this.state = {
      project_id: 'all',
      in_charge: Utils.getLocalData({ id: 'project/calender/in_charge', default: 'my' }),
    };
  }

  changeSetting() {
    this.setState({ project_id: this.project_id.value });
  }

  changeInCharge(id) {
    this.setState({ in_charge: id });
    Utils.saveLocalData({ id: 'dashboard/calender/in_charge', data: id });
  }

  getInfluencerSchedule(schedule, inf) {
    let base = this.props.data;
    let status = inf.status;
    if (Object.keys(status).length > 0) {
      if (status.posting_date != null) {
        schedule.push(this.setSchedule.bind(this)('posting_date', inf, (status.is_post_complete == 1), status.posting_date));
      }
      let ary = base.report.insight_submission[inf.insta_user_id];
      if (ary != undefined) {
        ary.map((d) => { schedule.push(this.setSchedule.bind(this)('insight_submission', inf, (d.is_insight_update == 1), d.date)); });
      }
    }
    return schedule;
  }

  setSchedule(id, inf, is_checked, st_date, ed_date) {
    if (ed_date == undefined) ed_date = st_date;
    let base = this.props.data;
    return {
      id: Utils.getUniqueID(),
      act: id,
      insta_id: inf.insta_id,
      insta_user_id: inf.insta_user_id,
      thumbnail: inf.thumbnail,
      is_checked: is_checked,
      start_date: Utils.setDate(st_date, 'YYYY-MM-DD'),
      end_date: Utils.setDate(ed_date, 'YYYY-MM-DD'),
      show_event: base.event.showInfluencer.bind(this),
    };
  }

  render() {
    let data = this.props.data;
    let schedule = [];
    
    if (data && data.schedule) {
      data.schedule.map((d) => {
        d.project = Object.assign({}, data.project);
        schedule.push(d);
      });
      for (let i in data.workflow.influencers) {
        schedule = this.getInfluencerSchedule.bind(this)(schedule, data.workflow.influencers[i]);
      }
    }

    let show_mode = [
      { id: 'all', name: '全て表示' },
      { id: 'my',  name: '自分の担当のみ表示' },
    ];

    return (
      <div className="project-calender">
        <div className="calender-header">
          <div className="show-mode">
            {show_mode.map((d, key) => {
              let flg = (d.id == this.state.in_charge) ? 'on' : 'off';
              return <p key={key} className={flg} onClick={this.changeInCharge.bind(this, d.id)}>{d.name}</p>
            })}
          </div>
          <div className="project-select">
            <h6>インフルエンサー</h6>
            <div className="selectbox">
              <select ref={(input) => { this.project_id = input }} onChange={this.changeSetting.bind(this)}>
                <option value={'all'}>全て表示</option>
              </select>
            </div>
          </div>
        </div>
        <CalenderCommon schedule={schedule} mode="workflow" />
      </div>
    );
  }
}

// =======================================================
// 3. メイン画面 (タブ切り替え・全体管理)
// =======================================================
class InfluencerMain extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: 'list' // 初期状態はリスト表示
    };
  }

  // タブ切り替え処理
  handleTabChange(tab) {
    this.setState({ activeTab: tab });
  }

  render() {
    return (
      <div className="project-calender">
        <div className="calender-contents">
          {/* カスタムタブメニュー */}
          <div className="tab-wrapper" style={{ display: 'flex', borderBottom: '1px solid #ccc', marginBottom: '20px' }}>
            <div 
              onClick={this.handleTabChange.bind(this, 'list')}
              style={{ 
                padding: '10px 20px', 
                cursor: 'pointer', 
                borderBottom: this.state.activeTab === 'list' ? '3px solid #007bff' : 'none',
                fontWeight: this.state.activeTab === 'list' ? 'bold' : 'normal'
              }}
            >
              リスト
            </div>
            <div 
              onClick={this.handleTabChange.bind(this, 'calendar')}
              style={{ 
                padding: '10px 20px', 
                cursor: 'pointer', 
                borderBottom: this.state.activeTab === 'calendar' ? '3px solid #007bff' : 'none',
                fontWeight: this.state.activeTab === 'calendar' ? 'bold' : 'normal'
              }}
            >
              カレンダー
            </div>
          </div>

          {/* 表示コンテンツの分岐 */}
          <div className="main-contents">
            {this.state.activeTab === 'list' ? (
              <InfluencerList data={this.props.data} />
            ) : (
              <Calender data={this.props.data} />
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default InfluencerMain;